import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center" }
const _hoisted_2 = { class: "font-extrabold text-3xl" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "color-grey-5 mt-2 mb-4" }, "Transaksi Belum Diapprove", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Lihat Detail ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-right text-xs font-extrabold" }, null, -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

import Card from 'primevue/card'
import { onMounted, ref } from 'vue'
import InlineSvg from 'vue-inline-svg'
import apiUsecase from '@/usecase/apiUseCase'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'CardTransaction',
  setup(__props) {

const totalRecod = ref(0)
const store = useStore()
const router = useRouter()
const prohibitedRoles = ref(['Roster', 'Adminkontrol'])

const initialize = () => {
  apiUsecase.get('transaction/v1/TransactionPp/Deposit', '?isApproved=false')
    .then(({ error, count }) => {
      if (!error) {
        totalRecod.value = count
      }
    })
}

const toPage = () => {
  store.dispatch('approvePp/setSelectedStatus', 2)
  router.push({
    // path: baseRoute.value
    name: 'approve-deposits',
  })
}

onMounted(() => {
  console.log('state', store.state)
  console.log('cek', prohibitedRoles.value.includes(store.state.userProfile?.RolesName) ? 'true' : 'false')
  initialize()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), { class: "card-no-shadow" }, {
    content: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(totalRecod.value) + " Transaksi", 1),
          _createVNode(_unref(InlineSvg), {
            src: require('@/assets/img/icon/park-solid-transaction.svg')
          }, null, 8, ["src"])
        ]),
        _hoisted_3,
        _createElementVNode("div", {
          class: "color-blue-1 font-extrabold cursor-pointer w-fit",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toPage()))
        }, _hoisted_6)
      ])
    ]),
    _: 1
  }))
}
}

})